import ApiService from "../api/apiService";
import { jwtDecode } from "jwt-decode";

export const saveTokenToCookies = (accessToken, refreshToken, isRememberMe) => {
  clearLastRefreshAccessToken();
  const now = new Date();

  const accessExpiry = new Date(now.getTime() + 2 * 60 * 60 * 1000);
  document.cookie = `token=${accessToken};expires=${accessExpiry.toUTCString()};path=/`;

  if (refreshToken && isRememberMe) {
    const refreshExpiry = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);

    document.cookie = `refreshToken=${refreshToken};expires=${refreshExpiry.toUTCString()};path=/`;
  } else {
    document.cookie =
      "refreshToken=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
  }
};

export const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
};

let refreshInFlight = null;
// Token from the latest successful refresh. A fast system clock still treats
// that token as expired, and refreshing it again loops.
let lastRefreshAccessToken = null;

const clearLastRefreshAccessToken = () => {
  lastRefreshAccessToken = null;
};

export const wasJustRefreshed = (token) =>
  Boolean(token) && token === lastRefreshAccessToken;

const performRefresh = async () => {
  const refreshToken = getCookie("refreshToken");

  if (!refreshToken) return null;

  const response = await ApiService.v2.account.refreshToken(refreshToken);

  if (!response?.accessToken) return null;

  const now = new Date();
  const accessExpiry = new Date(now.getTime() + 2 * 60 * 60 * 1000);

  document.cookie = `token=${
    response.accessToken
  };expires=${accessExpiry.toUTCString()};path=/`;

  lastRefreshAccessToken = response.accessToken;
  return response.accessToken;
};

export const handleRefreshToken = () => {
  if (refreshInFlight) return refreshInFlight;

  refreshInFlight = Promise.resolve()
    .then(performRefresh)
    .catch((err) => {
      console.error("Refresh failed:", err);
      return null;
    })
    .finally(() => {
      refreshInFlight = null;
    });

  return refreshInFlight;
};

export const isTokenExpired = (token) => {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};

export const expiredSession = () => {
  clearLastRefreshAccessToken();
  document.cookie = "token=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
  document.cookie =
    "refreshToken=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";

  window.location.href = "/login";
};

export const saveUserDetailsToLocalStorage = (userDetails) => {
  localStorage.setItem("userDetails", JSON.stringify(userDetails));
};

export const userLogout = () => {
  clearLastRefreshAccessToken();
  document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  document.cookie =
    "refreshToken=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
  localStorage.removeItem("userDetails");
};
